import { useMemo, type CSSProperties } from "react";

export function PrayerRing(props: {
  progress: number; // 0..1
  size?: number;
  labelTop: string;
  labelMain: string;
  labelSub?: string;

  /** Enable calm breathing animation (ultra subtle). */
  breathing?: boolean;
  /** 0..1 intensity for ambient glow. */
  intensity?: number;
}) {
  const size = props.size ?? 180;
  const stroke = Math.max(10, Math.round(size * 0.07));
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;

  const p = Math.max(0, Math.min(1, props.progress));
  const dash = useMemo(() => {
    const filled = c * p;
    return `${filled} ${c - filled}`;
  }, [c, p]);

  const breath = props.breathing !== false;
  const intensity = Math.max(0, Math.min(1, props.intensity ?? 0.35));

  const vars: Record<string, string> = { "--ring-intensity": String(intensity) };

  return (
    <div
      className={"ringWrap ringAnchor" + (breath ? " ringBreath" : "")}
      style={{ width: size, height: size, ...vars } as unknown as CSSProperties}
    >
      <svg width={size} height={size} className="ringSvg" aria-hidden="true">
        <circle className="ringTrack" cx={size / 2} cy={size / 2} r={r} strokeWidth={stroke} fill="none" />
        <circle
          className="ringValue"
          cx={size / 2}
          cy={size / 2}
          r={r}
          strokeWidth={stroke}
          fill="none"
          strokeDasharray={dash}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>

      <div className="ringText">
        <div className="ringTop">{props.labelTop}</div>
        <div className="ringMain">{props.labelMain}</div>
        {props.labelSub ? <div className="ringSub">{props.labelSub}</div> : null}
      </div>
    </div>
  );
}
